module.exports = __webpack_public_path__ + "static/media/logo300.9d93a9ca.png";